import CCatalog from './application/components/CCatalog/CCatalog.vue'
import CProduct from './application/components/CProduct/CProduct.vue'

export { CCatalog, CProduct }
